import { render } from "./CmsContent.vue?vue&type=template&id=0e42cdd8"
const script = {}

import "./CmsContent.vue?vue&type=style&index=0&id=0e42cdd8&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__